import { Accordion, Button, Card, CardColors, Link } from '@/ui'

export const AnnualTaxFaq = () => (
  <Card color={CardColors.LEVEL_0}>
    <Accordion
      type="multiple"
      collapsible
      variant="header"
      className="border-none"
      items={[
        {
          title: 'FAQs',
          content: (
            <div className="flex flex-col space-y-4">
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4420597856535-What-are-annual-taxes-"
                newPage
              >
                When are my annual taxes due?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4420597867287-Which-forms-do-I-need-to-file-"
                newPage
              >
                Which forms do I need to file?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/19233040314775"
                newPage
              >
                What tax documents should I look out for?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4420597872023-What-do-I-need-to-know-about-tax-deductions-"
                newPage
              >
                What do I need to know about tax deductions?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4420580970007-How-do-annual-taxes-work-with-Heard-"
                newPage
              >
                How do annual taxes work with Heard?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/sections/4416196135959-Annual-Taxes"
                newPage
              >
                <Button variant="link" className="ml-0 pl-0">
                  View All FAQs
                </Button>
              </Link>
            </div>
          ),
        },
      ]}
    />
  </Card>
)
